import * as React from 'react';

import { cn } from '@/lib/utils';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    icon?: React.ReactNode;
    endIcon?: React.ReactNode;
    iconPosition?: 'start' | 'end';
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, icon, endIcon, iconPosition = 'start', ...props }, ref) => {
        return (
            <div className='relative flex w-full items-center'>
                {iconPosition === 'start' && icon && (
                    <div
                        className={cn(
                            'absolute left-3 flex items-center justify-center cursor-pointer text-purple-lavender [&_svg]:size-5',
                        )}
                    >
                        {icon}
                    </div>
                )}
                <input
                    type={type}
                    className={cn(
                        'flex h-10 w-full bg-gray-light px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[#917EB1] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm text-purple',
                        iconPosition === 'start' && icon && 'pl-10',
                        ((iconPosition === 'end' && icon) || endIcon) && 'pr-10',
                        className,
                    )}
                    ref={ref}
                    {...props}
                />
                {((iconPosition === 'end' && icon) || endIcon) && (
                    <div className={cn('absolute right-3 flex text-purple-lavender items-center justify-center')}>
                        {iconPosition === 'end' ? icon : endIcon}
                    </div>
                )}
            </div>
        );
    },
);

Input.displayName = 'Input';

export { Input };
